import React, { createContext, useEffect, useState } from "react";
import * as apiServices from "../../api";
import { iconos } from "../global/iconos";

export const ConfigurationContext = createContext({});

export const ConfigurationProvider = ({ children }) => {
  const [isLoginPage, setIsLoginPage] = useState(false);
  const handlerIsLoginPage = (bool) => setIsLoginPage(bool);

  const [autenticado, setAutenticado] = useState(false);
  const handlerAutenticado = (bool) => setAutenticado(bool);

  const [alertasPersonalizadas, setAlertasPersonalizadas] = useState({});

  const getAlertaPersonalizada = async (id = 0, nombre = "") => {
    await apiServices.ajustes
      .getAlertaPersonalizada(id, nombre)
      .then((res) => setAlertasPersonalizadas(res.data.result))
      .catch((err) => console.error(err));
  };

  const mostrarMensajeAlerta = (codigoMensaje) => {
    return alertasPersonalizadas.find((x) => x.nombre === codigoMensaje)
      .mensaje;
  };

  const [menu, setMenu] = useState([]);
  const [triggerMenu, setTriggerMenu] = useState(0);

  const [idDispositivo,setIdDispositivo] = useState("")
  const [listaDispositivosSeguro,setListaDispositivoSeguro] = useState([])

  const esDispositivoActualSeguro = () => {
    const dispositivo = listaDispositivosSeguro.find(a=>a.identificadorDispositivo === idDispositivo)
    return dispositivo !== undefined
  }

  const [correoTitular,setCorreoTitular] = useState("");
  const [contratoTitular,setContratoTitular] = useState("")

  const [isLoading, setIsLoading] = useState(false);

  const [numeroCasoNotificacion,setNumeroCasoNotificacion] = useState("")

  useEffect(() => {
    setIsLoading(true);
    apiServices.ajustes
      .getMenu()
      .then((response) => {
        let lista = [];
        response.data.result
          .filter((r) => r.activo === true)
          .forEach((item) => {
            if (!item.padre) {
              lista.push({
                codigo: item.id,
                descripcion: item.descripcion,
                icono: iconos[item.icono],
                hasChild: false,
                childEvent: {},
                requireLogin: item.requireLogin,
                url: item.enlace ? item.enlace : "",
                children: [],
                isExterna: item.isExterna,
              });
            } else {
              if (
                lista.filter((a) => a.codigo === item.padre)[0].children ===
                  undefined ||
                lista.filter((a) => a.codigo === item.padre)[0].children ===
                  null
              ) {
                lista.filter((a) => a.codigo === item.padre)[0].children = [];
              }
              lista.filter((a) => a.codigo === item.padre)[0].hasChild = true;

              lista
                .filter((a) => a.codigo === item.padre)[0]
                .children.push({
                  codigo: item.id,
                  descripcion: item.descripcion,
                  icono: iconos[item.icono],
                  url: item.enlace,
                  requireLogin: item.requireLogin,
                  isExterna: item.isExterna,
                });

              if (
                lista
                  .filter((a) => a.codigo === item.padre)[0]
                  .children.filter((a) => a.requireLogin === false).length > 0
              ) {
                lista.filter(
                  (a) => a.codigo === item.padre
                )[0].requireLogin = false;
              }
            }
          });
        if (localStorage.getItem("autenticado") === "false") {
          lista = lista.filter((a) => a.requireLogin === false);
          lista.filter((item) => {
            if (item.children.length > 0) {
              item.children = item.children.filter(
                (a) => a.requireLogin === false
              );
            }
          });
        }
        setMenu(lista);
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setIsLoading(false);
      });

    return () => {
      setMenu([]);
    };
  }, [triggerMenu]);

  return (
    <ConfigurationContext.Provider
      value={{
        isLoginPage,
        handlerIsLoginPage,
        autenticado,
        handlerAutenticado,
        getAlertaPersonalizada,
        alertasPersonalizadas,
        mostrarMensajeAlerta,
        menu,
        setMenu,
        setTriggerMenu,
        numeroCasoNotificacion,
        setNumeroCasoNotificacion,
        idDispositivo,
        setIdDispositivo,
        setListaDispositivoSeguro,
        esDispositivoActualSeguro,
        correoTitular,
        setCorreoTitular,
        contratoTitular,
        setContratoTitular
      }}
    >
      {!isLoading ? children : null}
    </ConfigurationContext.Provider>
  );
};
